module.exports = __webpack_public_path__ + "img/home-video-bg.81201879.jpg";